import { useTranslation } from "react-i18next";
import { Clock4 } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";

// نافذة الحضور لم تبدأ بعد: لا كاميرا ولا استهلاك تحقق وجه — توقيت خاطئ لا مخالفة.
export const TooEarlyNotice = ({ check, onClose }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-5 py-8 text-center"
         data-testid="too-early-notice">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-amber-500/10 text-amber-500 shadow-neu-in">
        <Clock4 className="h-10 w-10" strokeWidth={2.2} />
      </span>
      <div>
        <p className="text-xl font-black text-amber-500" data-testid="too-early-title">{t("tooEarly.title")}</p>
        <p className="mx-auto mt-2 max-w-xs text-sm font-semibold text-muted-foreground">
          {t("tooEarly.reason", { opens: check.opens_local })}
        </p>
      </div>
      <div className="grid w-full max-w-xs grid-cols-2 gap-2">
        {[
          ["tooEarly.opensAt", check.opens_local || "-"],
          ["tooEarly.left", `${check.minutes_left || 0} ${t("app.minutes")}`],
        ].map(([label, value]) => (
          <div key={label} className="rounded-2xl p-3 shadow-neu-in">
            <p className="text-[11px] font-bold text-muted-foreground">{t(label)}</p>
            <p className="mt-1 font-mono text-lg font-black">{value}</p>
          </div>
        ))}
      </div>
      <NeuButton onClick={onClose} data-testid="too-early-close" className="mt-2 w-full max-w-xs py-3">
        {t("app.close")}
      </NeuButton>
    </div>
  );
};
